import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BlogsRoutingModule } from './blogs-routing.module';
import { BlogPageComponent } from './components/blog-page/blog-page.component';
import { BlogAddComponent } from './components/blog-add/blog-add.component';
import { BlogListComponent } from './components/blog-list/blog-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';


@NgModule({
  declarations: [BlogPageComponent, BlogAddComponent, BlogListComponent],
  imports: [
    CommonModule,
    BlogsRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
    NgxMatSelectSearchModule,
    CKEditorModule,
  ]
})
export class BlogsModule { }
